module.exports = __webpack_public_path__ + "img/AWS.4116e600.png";